// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA'
